<script setup>
    import config from "@/config";

    const URL = config.base_url.replace("/homeapi","");
    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    })

    const getContentImage = (value)=>{
        if(value.image != undefined && value.image.length > 0) {
            return value.image;
        }else{
            return URL + '/static/images/menu/empty.png';
        }
    }
    
    const isLoading = ref(true);
    watch(()=>props.data,(newValue,oldValue)=>{
        isLoading.value = false;
    },{ deep: true, immediate: true });
    
</script>

<template>
    <el-skeleton :loading="isLoading" animated>
        <template #template>
            <div class="column-wrap">
                
                <div class="products" v-if="props.data.style == 1">
                    <div class="products-image">
                        <el-skeleton-item variant="image" style="width: 570px; height: 305px; border-radius: 10px;" />
                    </div>
                    
                    <div class="products-list">
                        <div class="title">
                            <span><el-skeleton-item variant="text" style="width: 80px;" /></span>
                            <span><el-skeleton-item variant="text" style="width: 30px;" /></span>
                        </div>
                        <div class="products-wrap">
                            <div class="products-box" v-for="value in 3" :key="value">
                                <div class="thumb-image">
                                    <el-skeleton-item variant="image" style="width: 190px; height: 190px; border-radius: 5px;" />
                                </div>
                                <div class="goods-name">
                                    <el-skeleton-item variant="text" style="width: 150px;" />
                                </div>
                                <div class="goods-price">
                                    <el-skeleton-item variant="text" style="width: 30px;" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="products" v-if="props.data.style == 2">
                    <div class="products-list">
                        <div class="title">
                            <span><el-skeleton-item variant="text" style="width: 80px;" /></span>
                            <span><el-skeleton-item variant="text" style="width: 30px;" /></span>
                        </div>
                        <div class="products-wrap">
                            <div class="products-box" v-for="value in 3" :key="value">
                                <div class="thumb-image">
                                    <el-skeleton-item variant="image" style="width: 190px; height: 190px; border-radius: 5px;" />
                                </div>
                                <div class="goods-name">
                                    <el-skeleton-item variant="text" style="width: 150px;" />
                                </div>
                                <div class="goods-price">
                                    <el-skeleton-item variant="text" style="width: 30px;" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="products-image">
                        <el-skeleton-item variant="image" style="width: 570px; height: 305px; border-radius: 10px;" />
                    </div>
                </div>

                <div class="goods" v-if="props.data.style == 3">
                    <div class="goods-image">
                        <el-skeleton-item variant="image" style="width: 330px; height: 317px; border-radius: 10px;" />
                    </div>

                    <div class="goods-list">
                        <div class="title">
                            <span><el-skeleton-item variant="text" style="width: 80px;" /></span>
                            <span><el-skeleton-item variant="text" style="width: 30px;" /></span>
                        </div>
                        <div class="goods-wrap">
                            <div class="goods-box" v-for="value in 4" :key="value">
                                <div class="thumb-image">
                                    <el-skeleton-item variant="image" style="width: 200px; height: 200px; border-radius: 5px;" />
                                </div>
                                <div class="goods-name">
                                    <el-skeleton-item variant="text" style="width: 160px;" />
                                </div>
                                <div class="goods-price">
                                    <el-skeleton-item variant="text" style="width: 50px;" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </template>
        <template #default>
            <div class="column-wrap">
                
                <div class="products" v-if="props.data.style == 1">
                    <div class="products-image">
                        <a-link :to="props.data.data[0].link.path"><img :src="getContentImage(props.data.data[0] != undefined ? props.data.data[0] : {image: ''})" /></a-link>
                    </div>
                    
                    <div class="products-list">
                        <div class="title">
                            <span>{{ props.data.data[1] != undefined ? props.data.data[1].title : '标题名称' }}</span>
                            <span><a-link :to="props.data.data[1].link.path">更多 ></a-link></span>
                        </div>
                        <div class="products-wrap" v-if="props.data.data[1] != undefined && props.data.data[1].list != undefined">
                            <div class="products-box" v-for="(value,index) in props.data.data[1].list.slice(0,3)" :key="index">
                                <div class="thumb-image">
                                    <a-link :to="value.link.path"><img :src="getContentImage(value)" /></a-link>
                                </div>
                                <div class="goods-name wb2">
                                    <a-link :to="value.link.path">{{ value.name }}</a-link>
                                </div>
                                <div class="goods-price">￥{{ value.sell_price || "100.00" }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="products" v-if="props.data.style == 2">
                    <div class="products-list">
                        <div class="title">
                            <span>{{ props.data.data[0] != undefined ? props.data.data[0].title : '标题名称' }}</span>
                            <span><a-link :to="props.data.data[0].link.path">更多 ></a-link></span>
                        </div>
                        <div class="products-wrap" v-if="props.data.data[0] != undefined && props.data.data[0].list != undefined">
                            <div class="products-box" v-for="(value,index) in props.data.data[0].list.slice(0,3)" :key="index">
                                <div class="thumb-image">
                                    <a-link :to="value.link.path"><img :src="getContentImage(value)" /></a-link>
                                </div>
                                <div class="goods-name wb2">
                                    <a-link :to="value.link.path">{{ value.name }}</a-link>
                                </div>
                                <div class="goods-price">￥{{ value.sell_price }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="products-image">
                        <a-link :to="props.data.data[1].link.path"><img :src="getContentImage(props.data.data[1] != undefined ? props.data.data[1] : {image: ''})" /></a-link>
                    </div>
                </div>

                <div class="goods" v-if="props.data.style == 3">
                    <div class="goods-image">
                        <a-link :to="props.data.data[0].link.path"><img :src="getContentImage(props.data.data[0] != undefined ? props.data.data[0] : {image: ''})" /></a-link>
                    </div>

                    <div class="goods-list">
                        <div class="title">
                            <span>{{ props.data.data[1] != undefined ? props.data.data[1].title : '标题名称' }}</span>
                            <span><a-link :to="props.data.data[1].link.path">更多 ></a-link></span>
                        </div>
                        <div class="goods-wrap" v-if="props.data.data[1] != undefined && props.data.data[1].list != undefined">
                            <div class="goods-box" v-for="(value,index) in props.data.data[1].list.slice(0,4)" :key="index">
                                <div class="thumb-image">
                                    <a-link :to="value.link.path"><img :src="getContentImage(value)" /></a-link>
                                </div>
                                <div class="goods-name wb2">
                                    <a-link :to="value.link.path">{{ value.name }}</a-link>
                                </div>
                                <div class="goods-price">￥{{ value.sell_price }}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </template>
    </el-skeleton>
</template>

<style lang="scss" scoped>
.column-wrap {
    width: 1200px;
    min-height: 315px;
    margin: 0 auto;
    .products {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        .products-image {
            margin-top: 8px;
            img {
                width: 570px;
                height: 305px;
                border-radius: 10px;
            }
        }
        .products-list {
            width: 615px;
            .title {
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding-bottom: 15px;
                border-bottom: 1px solid #c4c4c4;
                span {
                    &:first-child {
                        color: #000;
                        font-size: 20px;
                    }
                    &:last-child {
                        color: #666;
                        font-size: 13px;
                        position: relative;
                        top: 7px;
                        a {
                            color: #666;
                            text-decoration: none;
                            font-size: 13px;
                            &:hover {
                                color: #dc143c;
                            }
                        }
                    }
                }
            }
            .products-wrap {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                width: 100%;
                margin-top: 15px;
                .products-box {
                    width: 33.33%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .thumb-image {
                        img {
                            width: 190px;
                            height: 190px;
                            border-radius: 5px;
                        }
                    }
                    .goods-name {
                        width: 100%;
                        text-align: left;
                        font-size: 14px;
                        color: #0054b7;
                        padding-left: 10px;
                        margin-top: 14px;
                        a {
                            color: #0054b7;
                            text-decoration: none;
                            font-size: 14px;
                            &:hover {
                                color: #dc143c;
                            }
                        }
                    }
                    .goods-price {
                        width: 100%;
                        text-align: left;
                        color: #f00000;
                        font-size: 18px;
                        padding-left: 10px;
                        margin-top: 12px;
                    }
                }
            }
        }
    }

    .goods {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        .goods-image {
            img {
                width: 330px;
                height: 317px;
                border-radius: 10px;
            }
        }
        .goods-list {
            width: 855px;
            .title {
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding-bottom: 15px;
                border-bottom: 1px solid #c4c4c4;
                span {
                    &:first-child {
                        color: #000;
                        font-size: 20px;
                    }
                    &:last-child {
                        color: #666;
                        font-size: 13px;
                        position: relative;
                        top: 7px;
                        a {
                            color: #666;
                            text-decoration: none;
                            font-size: 13px;
                            &:hover {
                                color: #dc143c;
                            }
                        }
                    }
                }
            }
            .goods-wrap {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                width: 100%;
                margin-top: 15px;
                .goods-box {
                    width: 25%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .thumb-image {
                        img {
                            width: 200px;
                            height: 200px;
                            border-radius: 5px;
                        }
                    }
                    .goods-name {
                        width: 100%;
                        text-align: left;
                        font-size: 14px;
                        color: #0054b7;
                        padding-left: 10px;
                        margin-top: 14px;
                        a {
                            color: #0054b7;
                            text-decoration: none;
                            font-size: 14px;
                            &:hover {
                                color: #dc143c;
                            }
                        }
                    }
                    .goods-price {
                        width: 100%;
                        text-align: left;
                        color: #f00000;
                        font-size: 18px;
                        padding-left: 10px;
                        margin-top: 12px;
                    }
                }
            }
        }
    }
}
</style>